import queryString from "query-string";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Form from "./campaign form components/Form";
import { Loader } from "../../../components";
import { useAxios, useComponent } from "../../../hooks";
import {
  connectionLists,
  createCampaignObject,
  getAudienceDetails,
  objectFromResponse,
} from "./campaign form components/campaignObject";
import { audienceObject } from "./audience details components/audienceObjects";

export default function CampaignDetails() {
  const axios = useAxios();
  const params = useParams();
  const { loader } = useComponent();
  const mode = queryString.parse(window.location.search).mode;

  const campaignID = params.campaignID || "";

  const { activeBrand, categories, userID, agent } = useSelector(
    (state) => state.memberDetails
  );

  if (agent?.length > 0) {
    createCampaignObject.agentId.value = agent;
  }

  const [agents, setAgents] = useState({});
  const [audiences, setAudiences] = useState([]);
  const [editState, setEditState] = useState(true);
  const [audienceSize, setAudienceSize] = useState();
  const [connectionList, setConnectionList] = useState([]);
  const [audienceCreated, setAudienceCreated] = useState("");
  const [preferredChannels, setPreferedChannels] = useState([]);
  const [formData, setFormData] = useState(createCampaignObject);
  const [audienceData, setAudienceData] = useState(audienceObject);

  useEffect(() => {
    if (!!campaignID) {
      setEditState(false);
    }

    if (mode === "edit") {
      setEditState(true);
    }

    const fetchData = async () => {
      loader.start(campaignID ? 5 : 2);

      try {
        const audiencesRes = await axios({
          url: `/brands/${activeBrand.ID}/audiences`,
        });
        if (audiencesRes.status) setAudiences(audiencesRes.data);
        loader.apiComplete();

        const channelsRes = await axios({
          url: "/get/campaign/preferredChannels",
        });
        if (channelsRes.status) {
          setPreferedChannels(channelsRes.data);

          if (channelsRes.data.length > 0) {
            const agentsRes = await axios({
              url: "/get/brandAgentDetails",
              method: "POST",
              data: { brand_id: activeBrand.ID },
            });
            if (agentsRes.status) {
              const data = {};
              agentsRes.data.forEach((agent) => {
                const key = Object.keys(agent)[2];
                data[key] = agent[key];
              });
              setAgents(data);
            }
          }
        }
        loader.apiComplete();

        if (campaignID) {
          const campaignRes = await axios({
            url: `/user/brand/getCampaign?brandId=${activeBrand.ID}&campaignId=${campaignID}`,
          });

          if (campaignRes.status) {
            const audienceId = campaignRes.data.audience.audience_id;

            const [audienceRes, sizingRes, creativesRes] = await Promise.all([
              axios({ url: `/brand/getDetailsOfAudience/${audienceId}` }),
              axios({
                url: "/get/audienceSizing",
                method: "POST",
                data: {
                  brand_id: activeBrand.ID,
                  campaign_id: campaignID,
                  audience_id: audienceId,
                },
                disableRedirect: true,
                disableError: true,
              }),
              axios({
                url: `/user/brand/campaign/creatives?campaignId=${campaignID}`,
              }),
            ]);

            if (audienceRes.status) {
              setAudienceData(getAudienceDetails(audienceRes.data));
            }
            if (sizingRes.status) {
              setAudienceSize(sizingRes.data);
            }

            if (creativesRes.status) {
              const campaignData = {
                ...campaignRes.data,
                creatives: creativesRes.data,
              };
              setConnectionList(
                connectionLists(campaignRes.data?.connections || [])
              );
              if (campaignData.status !== "CREATED") setEditState(false);
              setFormData(objectFromResponse(campaignData));
            }

            loader.apiComplete(3);
          }
        }
      } catch (error) {
        console.error(error);
        loader.apiComplete();
      }
    };

    fetchData();
  }, [activeBrand.ID, axios, loader, campaignID, mode, userID]);

  useEffect(() => {
    if (!audienceCreated) return;

    const fetchAllAudiences = async () => {
      const res = await axios({
        url: `/brand/getAllAudiences?brandId=${activeBrand.ID}`,
      });
      if (res.status) {
        const arr = res.data.map((key) => {
          const data = {};
          key.fields.forEach((field) => {
            data[Object.keys(field)[0]] = Object.values(field)[0];
          });
          return { ...data, audience_id: key.audience_id };
        });
        setAudiences(arr);
      }
    };

    fetchAllAudiences();
  }, [audienceCreated, axios, activeBrand.ID]);

  return (
    <Loader>
      <Form
        agents={agents}
        audienceSize={audienceSize}
        formData={formData}
        audiences={audiences}
        editState={editState}
        categories={categories}
        setEditState={setEditState}
        audienceData={audienceData}
        connectionList={connectionList}
        setAudienceData={setAudienceData}
        preferredChannels={preferredChannels}
        setAudienceCreated={setAudienceCreated}
      />
    </Loader>
  );
}
